module.exports = __webpack_public_path__ + "img/soln-meta-wordplay.0c376308.jpg";